@if (atgard$ | async; as atgard) {
  <div class="row">
    <div class="col-7">
      @if (drivningspunkter$ | async; as drivningspunkter) {
        <rask-textmultiline label="drivningspunkter" [infoTemplate]="infoTemplate">
          <div class="text-icon">
            <div class="icon">
              <i class="far fa-solid"
              [ngClass]="{'fa-circle-minus': drivningspunkter.isLarmkoordinatInvalid, 'fa-circle-check': !drivningspunkter.isLarmkoordinatInvalid }"></i>
            </div>
            <span class="text">
              @if (drivningspunkter.isLarmkoordinatInvalid ) {
                Åtgärden saknar larmkoordinat
              } @else {
                Åtgärden har en larmkoordinat
              }
            </span>
          </div>
          <div class="text-icon">
            <div class="icon">
              <i class="far fa-solid"
              [ngClass]="{'fa-circle-minus': drivningspunkter.isAvlaggInvalid || drivningspunkter.isAvlaggMissing , 'fa-circle-check': !drivningspunkter.isAvlaggInvalid }"></i>
            </div>
            <span class="text">
              @if (drivningspunkter.isAvlaggMissing) {
                Åtgärden saknar avlägg, det krävs minst ett
              } @else if (drivningspunkter.isAvlaggInvalid) {
                Det finns avlägg på åtgärden som saknar tillg. klass
              } @else {
                Åtgärd har avlägg med tillg. klass
              }
            </span>
          </div>
        </rask-textmultiline>
      }
    </div>
    <div class="col-5">
      <rask-simple-selector class="w-100" label="Tillgänglighet väg"
        [values]="atgard.tillganglighetItems"
        bindLabel="text"
        bindValue="value"
        [ngModel]="atgard.tillganglighetVag"
        (ngModelChange)="tillganglighetVagChange($event)"
        [raskDisabledControl]="atgard.isReadonly"
        raskVirkeskopRule [messageId]="['atgardTillganglighetVag']"
        [entityGuid]="atgard.guid">
      </rask-simple-selector>
    </div>
  </div>
  @if (drivningspunkter$ | async; as drivningspunkter) {
    @if(drivningspunkter.isAvlaggInvalid && !drivningspunkter.isAvlaggMissing) {
      <rask-label size="10" class="avlagg-label mb-0 mt-3">Följande avlägg saknar tillgänglighetsklass</rask-label>
      <div class="row" [ngClass]="drivningspunkter?.larmpunkter?.length > 0 ? '' : 'mb-3'">
        <div class ="col ms-3">
          @for(avlagg of drivningspunkter.avlaggUtanTillganglighetsKlass; track avlagg.guid;) {
            <a href="#" (click)="viewInMap($event, avlagg)"  class="me-2">
              <i class="far fa-map-marker-alt"></i>
              {{avlagg.kartgeometri.subtyp2}}
            </a>
          }
        </div>
      </div>
    }
    @if(drivningspunkter.larmpunkter.length > 0) {
      <rask-label size="10" class="larmpunkt-label mb-0 mt-3">Följande larmpunkter finns på åtgärden</rask-label>
      <div class="row mb-4">
        <div class ="col ms-3">
          @for (larmpunkt of drivningspunkter.larmpunkter; track larmpunkt.guid; ) {
            <a href="#" (click)="viewInMap($event, larmpunkt)" class="me-2">
              <i class="far fa-map-marker-alt"></i>
              {{larmpunkt.kartgeometri.subtyp2}}
            </a>
          }
        </div>
      </div>
    }
  }
}

<ng-template #infoTemplate>
  <div>För att verifiera åtgärdens drivningspunkter behöver det finnas:</div>
  <div class="text-icon">
    <div class="icon">
      <img src="dist/img/karta/larm.png">
    </div>
    <div class="text">
      <span>Endast en larmkoordinat</span>
    </div>
  </div>
  <div class="text-icon">
    <div class="icon">
      <img src="dist/img/karta/avlagg.png">
    </div>
    <div class="text">
      <span>Minst ett avlägg. Alla avlägg ska ha tillgänglighetsklass</span>
    </div>
  </div>
</ng-template>